import { useWindowSize } from "usehooks-ts";

// This hook is used to determine if the page is being viewed on a mobile device or desktop device.

const usePageWidthBreakpoint = (lowerBreakpoint = 450, upperBreakpoint = 950) => {
	const { width } = useWindowSize();
	const isMobile = width < lowerBreakpoint && width > 0;
	const isTablet = width >= lowerBreakpoint && width < upperBreakpoint;
	const isDesktop = width >= upperBreakpoint;
	return { isMobile, isTablet, isDesktop };
};

export default usePageWidthBreakpoint;
